//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "NotFound",

  computed: {
    ...mapGetters(['currentClient', 'urlCore']),
    isAuth: function () {
      return this.currentClient && Object.keys(this.currentClient).length !== 0;
    }
  },

  methods: {
    navigateToDashboard() {
      this.$router.push({name: 'dashboard'});
    },
    navigateToWizard() {
      this.$router.push({name: 'wizard'});
    },
  }
}
